module.exports = __webpack_public_path__ + "static/media/double_welted_pocket_with_buttonx2.0659f797.svg";